<div class="page-container flex flex-col gap-8">
  <app-page-header
    title="Toast test"
    description="Preview success, error, info, and warning toasts — title only, and title + message." />

  <section class="flex flex-col gap-3">
    <h2 class="text-sm font-semibold text-neutral-900">Success</h2>
    <div class="flex flex-wrap gap-2">
      <lib-signal-button appearance="primary" [fullWidth]="false" (clicked)="showSuccessTitleOnly()">
        Title only
      </lib-signal-button>
      <lib-signal-button appearance="primary" [fullWidth]="false" (clicked)="showSuccessTitleAndMessage()">
        Title + message
      </lib-signal-button>
    </div>
  </section>

  <section class="flex flex-col gap-3">
    <h2 class="text-sm font-semibold text-neutral-900">Error</h2>
    <div class="flex flex-wrap gap-2">
      <lib-signal-button appearance="primary" [fullWidth]="false" (clicked)="showErrorTitleOnly()">
        Title only
      </lib-signal-button>
      <lib-signal-button appearance="primary" [fullWidth]="false" (clicked)="showErrorTitleAndMessage()">
        Title + message
      </lib-signal-button>
    </div>
  </section>

  <section class="flex flex-col gap-3">
    <h2 class="text-sm font-semibold text-neutral-900">Info</h2>
    <div class="flex flex-wrap gap-2">
      <lib-signal-button appearance="primary" [fullWidth]="false" (clicked)="showInfoTitleOnly()">
        Title only
      </lib-signal-button>
      <lib-signal-button appearance="primary" [fullWidth]="false" (clicked)="showInfoTitleAndMessage()">
        Title + message
      </lib-signal-button>
    </div>
  </section>

  <section class="flex flex-col gap-3">
    <h2 class="text-sm font-semibold text-neutral-900">Warning</h2>
    <div class="flex flex-wrap gap-2">
      <lib-signal-button appearance="primary" [fullWidth]="false" (clicked)="showWarningTitleOnly()">
        Title only
      </lib-signal-button>
      <lib-signal-button appearance="primary" [fullWidth]="false" (clicked)="showWarningTitleAndMessage()">
        Title + message
      </lib-signal-button>
    </div>
  </section>

  <section class="flex flex-col gap-3">
    <h2 class="text-sm font-semibold text-neutral-900">Over dialog</h2>
    <div class="flex flex-wrap gap-2">
      <lib-signal-button appearance="outline" [fullWidth]="false" (clicked)="openConfirmPopup()">
        Confirm popup (Yes keeps open + toast)
      </lib-signal-button>
    </div>
  </section>

  <section class="flex flex-col gap-3 border-t border-slate-200 pt-8">
    <h2 class="text-sm font-semibold text-neutral-900">Slash caret demo</h2>
    <app-slash-caret-demo />
  </section>
</div>
